<template>
  <div class="flex">
    <button v-for="link in links"
            :key="link"
            class="bg-gray-100 py-2 px-3 mr-1 rounded hover:bg-blue-500 hover:text-white"
            :class="{ 'bg-blue-500 text-white': link == meta.current_page }"
            @click="$emit('change', link)">
      {{ link }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    meta: {
      type: Object,
      required: true
    }
  },

  computed: {
    links() {
      let links = [];

      for (let i = 1; i <= this.meta.last_page; i++) {
        links.push(i);
      }

      return links.length < 2 ? [] : links;
    }
  }
};
</script>
